import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class PluginGotenehusMappingDataService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/admin/plugin-gotenehus/mappings-data').pipe(map(({result}) => result));
    }

    update(id: number, value) {
        return this.api.put('/admin/plugin-gotenehus/mapping-data/' + id , value).pipe(map(({result}) => result));
    }

    create(value) {
        return this.api.post('/admin/plugin-gotenehus/mapping-data', value).pipe(map(({result}) => result));
    }

    syncData(tables: string[]) {
        return this.api.post(`/admin/plugin-gotenehus/sync`, {
            tables
        }).pipe(map(response => response));
    }

    delete(row) {
        if (row) {
            return this.api.delete('/admin/plugin-gotenehus/mapping-data/' + row.id).pipe(map(response => response));
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages-services/plugin-gotenehus-mapping-data.service.ts